import { createAction, props } from '@ngrx/store';

export const getAgencies = createAction('[Agency] Get Agencies');

export const getAgenciesSuccess = createAction('[Agency] Get Agencies Success', props<{ data: any }>());

export const getAgenciesFailure = createAction('[Agency] Get Agencies Failure', props<{ error: any }>());
